<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsInstituicao"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsInstituicao"
          addFilter
          :items="listarEscolaridade"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editInstituicao"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="instituicao.id === 0 ? addInstituicao() : editandoInstituicao()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="instituicao.id" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="instituicao.codinstituicao" required
              >Código</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="instituicao.descricao">Descrição</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Instituição Escolar',
      titleModal: '',
      titlePDF: 'Instituição Escolar',
      listarEscolaridade: [],
      baseUrlGestaoProjetosConcurso: '',
      instituicao: [],
      itemPorPage: '100',
      actionsInstituicao: [
        {
          button: true,
          funcaoButton: 'editInstituicao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteInstituicao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsInstituicao: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'codinstituicao', label: 'Código', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    linstandoInstituicao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      this.linstandoInstituicaoGenerico()
        .then((response) => {
          this.listarEscolaridade = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar instituição'
      this.instituicao = {}
      this.instituicao.id = 0
      this.$root.$emit('bv::show::modal', 'editInstituicao')
    },
    editInstituicao: function (_, item) {
      this.titleModal = 'Editar instituição'
      this.instituicao = item
      this.$root.$emit('bv::show::modal', 'editInstituicao')
    },
    editandoInstituicao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'Instituicao/Alterar',
          this.instituicao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.instituicao = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editInstituicao')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addInstituicao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'Instituicao/Adicionar',
          this.instituicao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.instituicao = {}
          this.linstandoInstituicao()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editInstituicao')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteInstituicao: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'Instituicao/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.linstandoInstituicao()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.linstandoInstituicao()
  }
}
</script>
